import { ImageApi } from '../Image/ImageApi';
import { ImageIndexedDbRepo } from '../Image/ImageIndexDBRepo';
import { FormApi } from '../Form/FormApi';
import { FormIndexedDBRepo } from '../Form/FormIndexedDBRepo';
import { AnswerIndexedDbRepo } from '../Form/AnswerIndexedDbRepo';
import { ManageRecords } from '../Record/use-cases.manageRecords';
import { RecordActions } from '../../Store/actions/record/recordActions';
import { RecordListActions } from '../../Store/actions/recordList/recordListActions';
import { ManageForms } from '../Form/use-cases.manageForms';
import { AnswerManager } from '../Form/AnswerManager';
import { AnswerApi } from '../Form/AnswerApi';

import { FillForm } from '../Form/use-cases.fillForm';
import { SyncRecords } from '../sync/use-cases.syncRecords';
import { RecordApi } from '../Record/RecordApi';
import { RecordIndexedDbRepo } from '../Record/RecordIndexedDbRepo';
import getLocalReferential from '../../services/Referential/getLocalReferential';
import { Report } from '../Report/Report';
import formDb from '../databases/forms';
import answerDb from '../databases/answers';
import recordDb from '../databases/records';
import imageDb from '../databases/images';
import { AuthClass } from '../Auth/Auth';
import saveReferentials from '../../services/Auth/saveReferentials';
import { Api } from '../../services/api/api';
import { SignProvider } from '../Auth/SignProvider/SignProvider';
import { Messenger } from '../sync/messages/Messenger';
import { declareMessenger } from '../sync/messages/declareMessenger';
import logError from '../../services/Error/postErrorForm';

const signProvider = new SignProvider();
Api.provider = signProvider;
export const api = Api.ApiService;

export const messenger = new Messenger(declareMessenger(navigator));

const imageHandler = new ImageApi(api);
const formHandler = new FormApi(api);
export const recordHandler = new RecordApi(api);
const imageRepo = new ImageIndexedDbRepo(imageDb);
const formRepo = new FormIndexedDBRepo(formDb);
const recordRepo = new RecordIndexedDbRepo(recordDb);
const answerHandler = new AnswerApi(api);
const answerRepo = new AnswerIndexedDbRepo(answerDb);
const answerManager = new AnswerManager({ answerRepo, answerHandler, messenger, formRepo });
export const Auth = new AuthClass(messenger, api);
const auth = Auth;
export const report = new Report({ auth, getLocalReferential, saveReferentials, recordHandler, logError });
export const formManager = new ManageForms({
  formHandler,
  formRepo,
  imageHandler,
  imageRepo,
  messenger,
  report,
  answerManager,
});
export const fillForm = new FillForm({ formManager, answerManager });
export const recordManager = new ManageRecords({ formManager, recordHandler, recordRepo });
const syncManager = new SyncRecords({ auth, recordManager });
export const recordActions = new RecordActions({ recordManager, auth, recordHandler });
export const recordListActions = new RecordListActions({ recordManager, auth, syncManager });
